<template>
    <div class="form-group" v-if="! is_busy">
        <label>Tags</label>
        <div class="form-group">
            <input type="text"
                   class="form-control"
                   placeholder="Search"
                   @keydown.enter.stop.prevent
                   v-model="search" />
        </div>
        <div v-for="s in filtered_groups" :key="s.id">
            <div class="tag">
                <div class="form-check">
                    <input type="checkbox"
                           :id="`group-${s.id}`"
                           class="form-check-input"
                           v-model="modelValue"
                           @change="updateSelected"
                           :value="s.id">
                    <label class="form-check-label"
                           :for="`group-${s.id}`">
                        <span class="tag-type">{{s.type}}:</span>
                        <span class="tag-name">{{s.name}}</span>
                        <span class="tag-desc" v-if="s.description">:{{s.description}}</span>
                        <span class="actions">
                            <span class="edit" @click.prevent.stop="editGroup(s)">Edit</span>
                            <span class="delete" @click.prevent.stop="deleteGroup(s)">Delete</span>
                        </span>
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group mt-3" @keyup.prevent.stop>
            <input type="text"
                   class="form-control"
                   :disabled="create.is_busy"
                   v-model="create.text"
                   placeholder="Create Tag <group:name:description>"
                   @keydown.enter.stop.prevent
                   @keyup.enter.stop.prevent="createGroup()">
        </div>
    </div>
</template>

<script>
import API from "@/API";

export default {
    name: "GroupsConnector",

    emits: ['update:modelValue'],

    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        types: {
            type: [Array,String],
            default: () => [],
        },
        scope: {
            type: String,
            default: 'custom', // internal, custom, both
        }
    },


    computed: {
        filtered_groups(){
            if( !this.search.length ) return this.groups;
            const regex = new RegExp(this.search, 'i');
            return this.groups.filter( g => regex.test( `${g.type}:${g.name}:${g.description}` ) );
        }
    },

    data(){
        return {
            create: {
                is_busy: false,
                text: '',
            },

            is_busy: true,
            search: '',
            groups: [],
        }
    },

    methods: {
        async createGroup(){
            try{
                this.create.is_busy = true;
                const group = await API.groups.create(this.create.text);
                this.groups.push(group);
                this.create.text = '';
                this.modelValue.push(group.id);
                this.updateSelected();
            }catch (e) {}
            this.create.is_busy = false;
        },

        groupText(group){
            return `${group.type}:${group.name}${group.description ? ':' + group.description : ''}`;
        },

        updateSelected(){
            this.$emit('update:modelValue', this.modelValue);
        },

        async editGroup(group){
            const tag = prompt('Edit Tag', this.groupText(group));
            const updated = await API.groups.update(group.id, tag);
            let idx = this.groups.findIndex(g => g.id === updated.id);
            if( ~idx ) this.groups[ idx ] = updated;
            else this.groups.push(updated);
        },

        async deleteGroup(group){
            if( !confirm(`Are you sure to permanently delete group "${this.groupText(group)}"?`) ) return;

            // Remove from selected groups, if selected.
            idx = this.modelValue.findIndex(id => id === group.id);
            if( ~idx ) this.modelValue.splice(idx, 1);
            this.updateSelected();

            // Remove from all groups if exists.
            let idx = this.groups.findIndex(g => g.id === group.id);
            if( ~idx ) this.groups.splice(idx, 1);


            // Finally delete from database.
            await API.groups.delete(group.id);
        },

    },


    async beforeMount() {
        const params = {};

        // {
        //     is_internal: this.internal,
        //         type: this.types
        // }

        console.log({scope: this.scope});

        if( this.scope === 'internal' ){
            params['is_internal'] = [1];
        }else if( this.scope === 'custom' ){
            params['is_internal'] = [0];
        }else if( this.scope === 'both' ){
            params['is_internal'] = [0, 1];
        }

        console.log({params});

        let types = this.types;

        if( typeof this.types === 'string' ){
            types = this.types.split(',');
        }

        if( this.types.length ){
            params['type'] = types;
        }

        this.groups = await API.groups.bulk(params);
        this.is_busy = false;
    },

}
</script>

<style lang="scss" scoped>


.tag{
    background: rgba($dark, .05);
    display: inline-block;
    padding: .1rem .4rem;
    margin-bottom: .2rem;
    border-radius: .2rem;
    cursor: pointer;
    user-select: none;

    label{
        cursor: pointer;
    }

    &:hover{
        background: $dark;
        color: white;

        .tag-type{
            color: $light;
        }

        .tag-name{
            color: $primary;
        }

        .actions{
            opacity: 1;
            display: inline;
        }

    }
}

.tag-type{
    color: lighten($dark, 25%);
}

.tag-name{
    color: lighten($dark, 5%);
    // margin-left: .2rem;
    display: inline-block;
}

.actions{
    //position: absolute;
    //top:0;
    //left: 100%;
    margin-left: 1rem;
    bottom: 0;
    border-radius: .3rem;
    overflow: hidden;
    opacity: 0;
    display: none;
    transition: opacity .3s;
}
.edit{
    background: $primary;
    color: white;
    padding: .2rem .4rem;
}
.delete{
    background: $danger;
    color: white;
    padding: .2rem .4rem;
}
</style>
